import { fabric } from "fabric";

fabric.Image.prototype.getSrc = function (filtered) {
  if (this.canvas?.printMode && this.imageSrcOriginal) {
    return this.imageSrcOriginal;
  }

  var element = filtered ? this._element : this._originalElement;
  if (element) {
    if (element.toDataURL) {
      return element.toDataURL();
    }

    if (this.srcFromAttribute) {
      return element.getAttribute('src');
    }
    else {
      return element.src;
    }
  }
  else {
    return this.src || '';
  }
}

fabric.Image.prototype.getSvgSrc =  fabric.Image.prototype.getSrc;